export var SchemaActionType;
(function (SchemaActionType) {
    SchemaActionType["CreateCollection"] = "create-collection";
    SchemaActionType["DropCollection"] = "drop-collection";
    SchemaActionType["CreateIndex"] = "create-index";
    SchemaActionType["DropIndex"] = "drop-index";
})(SchemaActionType || (SchemaActionType = {}));
export var DataActionType;
(function (DataActionType) {
    DataActionType["MoveProperty"] = "move-property";
    DataActionType["DropProperty"] = "drop-property";
    DataActionType["ReplaceProperty"] = "replace-property";
    DataActionType["ClearData"] = "clear-data";
    DataActionType["ReplaceData"] = "replace-data";
})(DataActionType || (DataActionType = {}));
//# sourceMappingURL=action.js.map